/**
 * Gestione varianti prodotto - come nel tema adviva
 * PrestaShop gestisce automaticamente il refresh quando cambiano le varianti
 * Questo script gestisce solo l'UI (opacità)
 */

$(document).ready(function () {

    // Aggiungi stili CSS per l'opacità delle varianti non selezionate
    var css = `
        <style id="variant-opacity-styles">
        .product-variants-item .input-container.variant-selected {
            opacity: 1 !important;
        }
        .product-variants-item .input-container:not(.variant-selected) {
            opacity: 0.6 !important;
            transition: opacity 0.3s ease;
        }
        .product-variants-item .input-container:not(.variant-selected):hover {
            opacity: 0.8 !important;
        }
        </style>
    `;
    $('head').append(css);

    // Funzione per inizializzare l'opacità delle varianti
    function initializeVariantOpacity() {
        $('.product-variants').each(function () {
            var $variantGroup = $(this);
            var attributeId = $variantGroup.find('[data-product-attribute]').first().data('product-attribute');

            // Trova la variante selezionata
            var $selectedVariant = $variantGroup.find('input:checked, select option:selected').first();
            if ($selectedVariant.length > 0) {
                var selectedValue = $selectedVariant.val();
                updateVariantOpacity(attributeId, selectedValue);
            }
        });
    }

    // Funzione per aggiornare l'opacità delle varianti
    function updateVariantOpacity(attributeId, selectedValue) {
        // Trova il gruppo di varianti per questo attributo
        var $variantGroup = $('.product-variants').find('[data-product-attribute="' + attributeId + '"]').closest('.product-variants-item');

        if ($variantGroup.length > 0) {
            // Rimuovi la classe variant-selected da tutte le varianti di questo gruppo
            $variantGroup.find('.input-container').removeClass('variant-selected');

            // Aggiungi la classe variant-selected alla variante selezionata
            var $selectedContainer = $variantGroup.find('input[value="' + selectedValue + '"]').closest('.input-container');
            if ($selectedContainer.length > 0) {
                $selectedContainer.addClass('variant-selected');
            }
        }
    }

    // Salva l'immagine corrente per la modale del carrello
    var savedImageSrc = null;
    var savedImageAlt = null;
    var savedImageTitle = null;
    var isUpdatingModalImage = false; // Flag per evitare loop infiniti nel MutationObserver

    // Funzione per salvare l'immagine corrente
    function saveCurrentImage() {
        var $coverImage = $('.image-container[data-cover-image-gallery] .cover-image img');
        if ($coverImage.length > 0) {
            savedImageSrc = $coverImage.attr('src');
            savedImageAlt = $coverImage.attr('alt');
            savedImageTitle = $coverImage.attr('title');
        }
    }

    // Salva l'immagine iniziale
    saveCurrentImage();

    // Listener per quando cambia una variante - triggera manualmente il refresh
    $('body').on('change', '.product-variants [data-product-attribute]', function () {
        var $input = $(this);
        var attributeId = $input.data('product-attribute');
        var attributeValue = $input.val();

        // Aggiorna l'opacità immediatamente in entrambi i form
        updateVariantOpacity(attributeId, attributeValue);

        // Trova il form più vicino e sincronizza con l'altro
        var $closestForm = $input.closest('form');
        var $form = $('#add-to-cart-or-refresh');
        var $stickyForm = $('#add-to-cart-or-refresh-sticky');

        // Sincronizza le varianti tra i due form (evita loop con flag)
        if ($form.length > 0 && $stickyForm.length > 0 && !$input.data('syncing')) {
            // Trova l'altro form
            var $targetForm = $closestForm.is('#add-to-cart-or-refresh') ? $stickyForm : $form;

            // Trova tutti gli input delle varianti nel form che ha cambiato
            var $variantInputs = $closestForm.find('.product-variants [data-product-attribute]');

            // Sincronizza ogni variante nell'altro form
            $variantInputs.each(function () {
                var $sourceInput = $(this);
                var attrId = $sourceInput.data('product-attribute');
                var attrValue = $sourceInput.val();

                // Trova l'input corrispondente nell'altro form
                var $targetInput = $targetForm.find('[data-product-attribute="' + attrId + '"]');

                if ($targetInput.length > 0) {
                    // Marca come in sincronizzazione per evitare loop
                    $targetInput.data('syncing', true);

                    if ($sourceInput.is('input[type="radio"]')) {
                        // Per i radio, seleziona quello con lo stesso valore
                        var $targetRadio = $targetInput.filter('[value="' + attrValue + '"]');
                        if ($targetRadio.length > 0 && !$targetRadio.is(':checked')) {
                            $targetRadio.prop('checked', true);
                        }
                    } else if ($sourceInput.is('select')) {
                        // Per i select, imposta il valore solo se diverso
                        if ($targetInput.val() !== attrValue) {
                            $targetInput.val(attrValue);
                        }
                    }

                    // Rimuovi il flag dopo un breve delay
                    setTimeout(function () {
                        $targetInput.removeData('syncing');
                    }, 100);
                }
            });
        }

        // Salva e aggiorna l'immagine nella modale quando cambia una variante (dopo che le immagini si aggiornano)
        setTimeout(function () {
            saveCurrentImage();
            // Aggiorna anche l'immagine nella modale se è già presente nel DOM
            updateModalImageIfPresent();
        }, 200);

        // Triggera manualmente il refresh perché PrestaShop non lo fa automaticamente per i radio
        // Usa un piccolo delay per assicurarsi che la sincronizzazione sia completata
        setTimeout(function () {
            // Usa il form che ha effettivamente cambiato per raccogliere i dati (ha i valori più aggiornati)
            var $sourceForm = $closestForm.length > 0 ? $closestForm : $form;
            // Ma usa sempre il form principale per token e id_product
            var $mainForm = $form;

            if ($mainForm.length > 0 && $sourceForm.length > 0) {
                var refreshUrl = $mainForm.attr('data-url-update');

                // Raccogli tutti i valori delle varianti selezionate dal form che ha cambiato (ha i valori più aggiornati)
                var formData = {};
                $sourceForm.find('.product-variants [data-product-attribute]').each(function () {
                    var $otherInput = $(this);
                    if ($otherInput.is(':checked') || $otherInput.is(':selected')) {
                        var otherAttrId = $otherInput.data('product-attribute');
                        var otherAttrValue = $otherInput.val();
                        formData['group[' + otherAttrId + ']'] = otherAttrValue;
                    }
                });

                // Aggiungi i campi base dal form principale
                formData.token = $mainForm.find('input[name="token"]').val();
                formData.id_product = $mainForm.find('input[name="id_product"]').val();
                formData.id_customization = $mainForm.find('input[name="id_customization"]').val() || 0;
                formData.refresh = '1';

                // Emetti updateProduct
                if (typeof prestashop !== 'undefined') {
                    prestashop.emit('updateProduct', {
                        eventType: 'updatedProductCombination',
                        reason: {
                            productUrl: refreshUrl,
                            productId: formData.id_product
                        }
                    });
                }

                // Costruisci l'URL corretto per il ProductController
                // Il refresh deve andare al ProductController, non al CartController
                // Rimuovi hash e query string esistenti
                var currentUrl = window.location.href;
                // Rimuovi hash (tutto dopo #)
                var urlWithoutHash = currentUrl.split('#')[0];
                // Rimuovi query string esistente (tutto dopo ?)
                var baseUrl = urlWithoutHash.split('?')[0];
                var productRefreshUrl = baseUrl + '?ajax=1&action=refresh';

                // Fai la chiamata AJAX
                $.ajax({
                    url: productRefreshUrl,
                    method: 'POST',
                    data: formData,
                    dataType: 'json',
                    success: function (response) {
                        // Aggiorna le immagini se presenti nella risposta
                        if (response && response.product_cover_thumbnails) {
                            // Il tema Panda usa .image-container con struttura personalizzata
                            var $coverContainer = $('.image-container[data-cover-image-gallery]');
                            if ($coverContainer.length > 0) {

                                // Estrai le immagini dalla risposta HTML
                                var $responseHtml = $(response.product_cover_thumbnails);
                                // Cerca solo le immagini principali nella gallery principale (non icone, non placeholder)
                                // Le immagini principali sono in .pro_gallery_top .swiper-slide img
                                var $images = $responseHtml.find('.pro_gallery_top .swiper-slide img, .pro_gallery_top img');

                                // Se non trova immagini lì, prova con .swiper-wrapper .swiper-slide img
                                if ($images.length === 0) {
                                    $images = $responseHtml.find('.swiper-wrapper .swiper-slide img');
                                }

                                // Filtra solo le immagini che hanno un src valido e non sono placeholder/icone
                                $images = $images.filter(function () {
                                    var src = $(this).attr('src') || $(this).data('src') || $(this).attr('data-src');
                                    // Escludi immagini placeholder, icone, o troppo piccole
                                    return src &&
                                        !src.match(/placeholder|icon|sprite|\.svg$/i) &&
                                        (src.match(/large_default|medium_default|home_default/i) || src.match(/\.(jpg|jpeg|png|webp)$/i));
                                });

                                if ($images.length > 0) {
                                    // Aggiorna le immagini nel container personalizzato
                                    var $otherImages = $coverContainer.find('.other-images');
                                    var $coverImage = $coverContainer.find('.cover-image img');

                                    if ($otherImages.length > 0 && $coverImage.length > 0) {
                                        // Aggiorna le immagini miniatura
                                        $otherImages.empty();
                                        $images.each(function (index) {
                                            var $img = $(this);
                                            var src = $img.attr('src') || $img.data('src') || $img.attr('data-src');
                                            var alt = $img.attr('alt') || '';

                                            if (src) {
                                                var $imageItem = $('<div class="image-item"><img src="' + src + '" alt="' + alt + '" /></div>');
                                                $otherImages.append($imageItem);

                                                // La prima immagine diventa la cover - aggiorna SOLO l'attributo src dell'img, non il contenuto del div
                                                if (index === 0) {
                                                    // Aggiorna solo l'immagine, non tutto il contenuto di .cover-image
                                                    // Usa un'immagine pre-caricata per evitare flash
                                                    var preloadImg = new Image();
                                                    preloadImg.onload = function () {
                                                        $coverImage.attr('src', src);
                                                        $coverImage.attr('alt', alt);
                                                    };
                                                    preloadImg.src = src;
                                                }
                                            }
                                        });

                                        // Re-inizializza product-cover.js dopo l'aggiornamento delle immagini
                                        setTimeout(function () {
                                            if (typeof ImageGallery !== 'undefined') {
                                                // Cerca l'istanza di ImageGallery e chiama reinitGallery
                                                var galleryInstance = window.imageGalleryInstance;
                                                if (galleryInstance && typeof galleryInstance.reinitGallery === 'function') {
                                                    galleryInstance.reinitGallery();
                                                }
                                            }
                                        }, 150);
                                    }
                                }
                            } else {
                                // Fallback: prova .images-container (template standard)
                                var $fallbackContainer = $('.images-container').first();
                                if ($fallbackContainer.length > 0) {
                                    $fallbackContainer.replaceWith(response.product_cover_thumbnails);
                                }
                            }
                        }

                        // Salva l'immagine aggiornata dopo il refresh e aggiorna la modale
                        setTimeout(function () {
                            saveCurrentImage();
                            // Aggiorna anche l'immagine nella modale se è già presente nel DOM
                            updateModalImageIfPresent();
                        }, 150);

                        // Emetti updatedProduct
                        if (typeof prestashop !== 'undefined') {
                            prestashop.emit('updatedProduct', {
                                eventType: 'updatedProductCombination',
                                reason: {
                                    productUrl: productRefreshUrl,
                                    productId: formData.id_product
                                },
                                resp: response
                            });
                        }
                    },
                    error: function (xhr, status, error) {
                        // Errore silenzioso
                    }
                });
            }
        }, 150); // Delay per assicurarsi che la sincronizzazione sia completata
    });

    // Listener per l'evento updatedProduct di PrestaShop (come nel tema adviva)
    if (typeof prestashop !== 'undefined') {
        prestashop.on('updatedProduct', function (event) {
            // Re-inizializza l'opacità delle varianti dopo l'aggiornamento
            setTimeout(function () {
                initializeVariantOpacity();
            }, 100);
        });
    }

    // Funzione per aggiornare l'immagine nella modale se è già presente nel DOM
    function updateModalImageIfPresent() {
        var $modalImage = $('#blockcart-modal .product-image');
        if ($modalImage.length > 0 && savedImageSrc) {
            var oldSrc = $modalImage.attr('src');
            // Aggiorna solo se l'immagine è diversa
            if (oldSrc !== savedImageSrc) {
                isUpdatingModalImage = true;
                $modalImage.attr('src', savedImageSrc);
                if (savedImageAlt) {
                    $modalImage.attr('alt', savedImageAlt);
                }
                if (savedImageTitle) {
                    $modalImage.attr('title', savedImageTitle);
                }
                // Reset flag dopo un breve delay
                setTimeout(function () {
                    isUpdatingModalImage = false;
                }, 100);
            }
        }
    }

    // Aggiorna l'immagine nella modale del carrello in base alla combinazione selezionata
    function updateBlockcartModalImage() {
        // Funzione per aggiornare l'immagine nella modale
        function doUpdateModalImage() {
            // Usa sempre l'immagine salvata (che viene aggiornata quando cambia la variante)
            var correctImageSrc = savedImageSrc;
            var correctImageAlt = savedImageAlt;
            var correctImageTitle = savedImageTitle;

            // Fallback: se non c'è immagine salvata, prendila dalla pagina
            if (!correctImageSrc) {
                var $coverImage = $('.image-container[data-cover-image-gallery] .cover-image img');
                if ($coverImage.length > 0) {
                    correctImageSrc = $coverImage.attr('src');
                    correctImageAlt = $coverImage.attr('alt');
                    correctImageTitle = $coverImage.attr('title');
                }
            }

            if (correctImageSrc) {
                // Aggiorna l'immagine nella modale
                var $modalImage = $('#blockcart-modal .product-image');

                if ($modalImage.length > 0) {
                    // Pre-carica l'immagine per evitare il flash
                    var img = new Image();
                    img.onload = function () {
                        // Aggiorna solo quando l'immagine è caricata
                        isUpdatingModalImage = true;
                        $modalImage.attr('src', correctImageSrc);
                        if (correctImageAlt) {
                            $modalImage.attr('alt', correctImageAlt);
                        }
                        if (correctImageTitle) {
                            $modalImage.attr('title', correctImageTitle);
                        }
                        // Reset flag dopo un breve delay
                        setTimeout(function () {
                            isUpdatingModalImage = false;
                        }, 100);
                    };
                    img.src = correctImageSrc;

                    // Se l'immagine è già in cache, aggiorna immediatamente
                    if (img.complete) {
                        isUpdatingModalImage = true;
                        $modalImage.attr('src', correctImageSrc);
                        if (correctImageAlt) {
                            $modalImage.attr('alt', correctImageAlt);
                        }
                        if (correctImageTitle) {
                            $modalImage.attr('title', correctImageTitle);
                        }
                        // Reset flag dopo un breve delay
                        setTimeout(function () {
                            isUpdatingModalImage = false;
                        }, 100);
                    }
                }
            }
        }

        // Usa MutationObserver per intercettare quando l'immagine viene aggiunta/modificata nella modale
        var modalObserver = new MutationObserver(function (mutations) {
            // Ignora se stiamo già aggiornando noi stessi
            if (isUpdatingModalImage) {
                return;
            }

            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
                    var $target = $(mutation.target);
                    if ($target.hasClass('product-image') && savedImageSrc) {
                        var currentSrc = $target.attr('src');
                        // Aggiorna solo se l'immagine è diversa da quella salvata
                        if (currentSrc !== savedImageSrc) {
                            isUpdatingModalImage = true;
                            $target.attr('src', savedImageSrc);
                            if (savedImageAlt) {
                                $target.attr('alt', savedImageAlt);
                            }
                            if (savedImageTitle) {
                                $target.attr('title', savedImageTitle);
                            }
                            // Reset flag dopo un breve delay
                            setTimeout(function () {
                                isUpdatingModalImage = false;
                            }, 100);
                        }
                    }
                } else if (mutation.type === 'childList') {
                    // Controlla se è stata aggiunta una nuova immagine
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType === 1) { // Element node
                            var $node = $(node);
                            var $img = $node.is('img.product-image') ? $node : $node.find('img.product-image');
                            if ($img.length > 0 && savedImageSrc) {
                                var currentSrc = $img.attr('src');
                                // Aggiorna solo se l'immagine è diversa da quella salvata
                                if (currentSrc !== savedImageSrc) {
                                    isUpdatingModalImage = true;
                                    $img.attr('src', savedImageSrc);
                                    if (savedImageAlt) {
                                        $img.attr('alt', savedImageAlt);
                                    }
                                    if (savedImageTitle) {
                                        $img.attr('title', savedImageTitle);
                                    }
                                    // Reset flag dopo un breve delay
                                    setTimeout(function () {
                                        isUpdatingModalImage = false;
                                    }, 100);
                                }
                            }
                        }
                    });
                }
            });
        });

        // Osserva il body per intercettare quando la modale viene creata
        var bodyObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) { // Element node
                        var $node = $(node);
                        // Se è la modale o contiene la modale
                        if ($node.is('#blockcart-modal') || $node.find('#blockcart-modal').length > 0) {
                            setTimeout(function () {
                                updateModalImageIfPresent();

                                // Osserva anche la modale stessa per cambiamenti all'immagine
                                var $modal = $('#blockcart-modal');
                                if ($modal.length > 0) {
                                    modalObserver.observe($modal[0], {
                                        childList: true,
                                        subtree: true,
                                        attributes: true,
                                        attributeFilter: ['src']
                                    });
                                }
                            }, 10);
                        }
                    }
                });
            });
        });

        // Osserva solo i figli diretti del body, non tutto il subtree
        bodyObserver.observe(document.body, {
            childList: true,
            subtree: false
        });

        // Ascolta quando la modale sta per essere mostrata (PRIMA che venga mostrata)
        $(document).on('show.bs.modal', '#blockcart-modal', function () {
            // Aggiorna immediatamente prima che la modale venga mostrata
            doUpdateModalImage();
        });

        // Fallback: aggiorna anche quando viene mostrata (nel caso il DOM non sia ancora pronto)
        $(document).on('shown.bs.modal', '#blockcart-modal', function () {
            // Aggiorna di nuovo per sicurezza
            setTimeout(doUpdateModalImage, 10);
        });

        // Fix: alla chiusura della modale rimuovi layer, body lock e backdrop così scroll e click tornano
        function cleanupBlockcartModal() {
            $('body').removeClass('modal-open');
            $('body').css({ overflow: '', paddingRight: '' });
            $('.modal-backdrop').remove();
            // Rimuovi il layer #blockcart-modal dal DOM così non resta sopra la pagina
            $('#blockcart-modal').remove();
        }
        $(document).on('hidden.bs.modal', '#blockcart-modal', cleanupBlockcartModal);
        // Pulsanti chiudi / continua: chiudi e pulisci (così il layer sparisce)
        $(document).on('click', '#blockcart-modal [data-dismiss="modal"], #blockcart-modal .close, #blockcart-modal .blockcart-modal__close', function (e) {
            e.preventDefault();
            $('#blockcart-modal').modal('hide');
            setTimeout(cleanupBlockcartModal, 350);
        });
        // Click sull'overlay: rimuovi subito layer e pulisci
        $(document).on('click', '#blockcart-modal', function (e) {
            if (e.target.id === 'blockcart-modal') {
                e.preventDefault();
                cleanupBlockcartModal();
            }
        });

        // Ascolta anche l'evento updatedCart di PrestaShop per aggiornare prima che la modale venga mostrata
        if (typeof prestashop !== 'undefined') {
            prestashop.on('updatedCart', function (event) {
                // Aggiorna immediatamente quando il carrello viene aggiornato
                setTimeout(doUpdateModalImage, 10);
            });
        }
    }

    // Inizializza l'opacità delle varianti al caricamento
    initializeVariantOpacity();

    // Inizializza l'aggiornamento dell'immagine nella modale
    updateBlockcartModalImage();
});
